export default __webpack_public_path__ + "static/media/WalletConnect-Logo.83c327dc.png";